import Nullstack from 'nullstack';
export default function IconBarrel({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-barrel",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M7.278 4h9.444a2 2 0 0 1 1.841 1.22c.958 2.26 1.437 4.52 1.437 6.78c0 2.26 -.479 4.52 -1.437 6.78a2 2 0 0 1 -1.841 1.22h-9.444a2 2 0 0 1 -1.841 -1.22c-.958 -2.26 -1.437 -4.52 -1.437 -6.78c0 -2.26 .479 -4.52 1.437 -6.78a2 2 0 0 1 1.841 -1.22z"
  }), "   ", Nullstack.element("path", {
    d: "M14 4c.667 2.667 1 5.333 1 8s-.333 5.333 -1 8"
  }), "   ", Nullstack.element("path", {
    d: "M10 4c-.667 2.667 -1 5.333 -1 8s.333 5.333 1 8"
  }), "   ", Nullstack.element("path", {
    d: "M4.5 16h15"
  }), "   ", Nullstack.element("path", {
    d: "M19.5 8h-15"
  }), " ");
}